import {DomainAncestor, entityConfig} from "core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {LovItem} from "core/metamodel/mdEntity";
import {IDomainObject} from "core/form/formUtils";
import {ID} from "core/metamodel/metaConstant";


export enum CERTTYPE {
  CAROOT = "CAROOT",
  CAINTERMEDIATE = "CAINTERMEDIATE",
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE"
}


export enum CERTFORMAT {
  X509_BASE64 = "X509_BASE64",
  X509_BINARY = "X509_BINARY",
  PKCS_12 = "PKCS_12"
}



@entityConfig()
export class MdCertificate extends DomainAncestor {

  @observable certificateId: number;
  @observable serialNumber: string;
  @observable issuerId: number;
  @observable certType: LovItem;
  @observable valid: boolean;
  @observable changeDate: string|Date;
  @observable fromDate: string|Date;
  @observable toDate: string|Date;
  @observable validError: string;
  @observable subjectCn: string;
  @observable issuerCn: string;
  x509String: string;

  constructor(json: IDomainObject) {
    super(json);
  }


  public getId(): ID {
    return this.certificateId;
  }

  public setId(id: ID): void {
    this.certificateId = <any>id;
  }

}


@entityConfig()
export class MdCertificateBeanConfig extends DomainAncestor {

  @observable beanName: string;
  @observable certificate: LovItem;

  constructor(json: IDomainObject) {
    super(json);
  }


  public getId(): ID {
    return this.beanName;
  }

  public setId(id: ID): void {
    this.beanName = <any>id;
  }

}




// WEBPACK FOOTER //
// ./src/administration/certificate/certificateDomain.ts